// Global settings / appearance / hero / new arrivals / buy-it-with / shipping (Phase 6).
import { api } from './client';

export const settingsApi = {
  // ---- Public (storefront) ----
  get(): Promise<{ settings: any }> {
    return api('/catalog/settings');
  },
  heroSlides(): Promise<{ items: any[] }> {
    return api('/catalog/hero-slides');
  },
  buyItWith(slug: string): Promise<any[]> {
    return api(`/catalog/products/${encodeURIComponent(slug)}/buy-it-with`);
  },
  shippingAreas(): Promise<{ items: any[] }> {
    return api('/catalog/shipping-areas');
  },

  // ---- Admin: site settings ----
  adminGet(): Promise<{ settings: any }> {
    return api('/admin/settings/general', { auth: true }).then((res: any) => ({ settings: res }));
  },
  update(body: Record<string, unknown>): Promise<{ ok: true }> {
    return api('/admin/settings/general', { method: 'PUT', body, auth: true });
  },

  // ---- Admin: hero slides ----
  adminHeroSlides(): Promise<{ items: any[] }> {
    return api('/admin/hero-slides', { auth: true });
  },
  createHeroSlide(image_url: string): Promise<{ id: string }> {
    return api('/admin/hero-slides', { method: 'POST', body: { image_url }, auth: true });
  },
  updateHeroSlide(id: string, body: Partial<{ image_url: string; is_visible: boolean; sort_order: number }>): Promise<{ ok: true }> {
    return api(`/admin/hero-slides/${id}`, { method: 'PUT', body, auth: true });
  },
  removeHeroSlide(id: string): Promise<{ ok: true }> {
    return api(`/admin/hero-slides/${id}`, { method: 'DELETE', auth: true });
  },

  // ---- Admin: new arrivals ----
  adminNewArrivals(): Promise<{ items: any[] }> {
    return api('/admin/new-arrivals', { auth: true });
  },
  addNewArrival(product_id: string): Promise<{ ok: true }> {
    return api('/admin/new-arrivals', { method: 'POST', body: { product_id }, auth: true });
  },
  reorderNewArrivals(order: string[]): Promise<{ ok: true }> {
    return api('/admin/new-arrivals/reorder', { method: 'PUT', body: { order }, auth: true });
  },
  updateNewArrival(id: string, body: Partial<{ is_visible: boolean; sort_order: number }>): Promise<{ ok: true }> {
    return api(`/admin/new-arrivals/${id}`, { method: 'PUT', body, auth: true });
  },
  removeNewArrival(id: string): Promise<{ ok: true }> {
    return api(`/admin/new-arrivals/${id}`, { method: 'DELETE', auth: true });
  },
  removeNewArrivalByProduct(product_id: string): Promise<{ ok: true }> {
    return api(`/admin/new-arrivals/product/${product_id}`, { method: 'DELETE', auth: true });
  },

  // Home Collections
  adminHomeCollections(): Promise<{ items: any[] }> {
    return api('/admin/home-collections', { auth: true });
  },
  addHomeCollection(category_id: string): Promise<{ ok: true }> {
    return api('/admin/home-collections', { method: 'POST', body: { category_id }, auth: true });
  },
  reorderHomeCollections(order: string[]): Promise<{ ok: true }> {
    return api('/admin/home-collections/reorder', { method: 'PUT', body: { order }, auth: true });
  },
  updateHomeCollection(id: string, body: Partial<{ is_visible: boolean; sort_order: number }>): Promise<{ ok: true }> {
    return api(`/admin/home-collections/${id}`, { method: 'PUT', body, auth: true });
  },
  removeHomeCollection(id: string): Promise<{ ok: true }> {
    return api(`/admin/home-collections/${id}`, { method: 'DELETE', auth: true });
  },
  removeHomeCollectionByCategory(category_id: string): Promise<{ ok: true }> {
    return api(`/admin/home-collections/category/${category_id}`, { method: 'DELETE', auth: true });
  },

  // ---- Admin: buy it with ----
  adminBuyItWith(productId: string): Promise<{ items: any[] }> {
    return api(`/admin/products/${productId}/buy-it-with`, { auth: true });
  },
  addBuyItWith(product_id: string, related_product_id: string): Promise<{ ok: true }> {
    return api(`/admin/products/${product_id}/buy-it-with`, { method: 'POST', body: { related_product_id }, auth: true });
  },
  updateBuyItWith(product_id: string, related_product_id: string, sort_order: number): Promise<{ ok: true }> {
    return api(`/admin/products/${product_id}/buy-it-with/${related_product_id}`, { method: 'PUT', body: { sort_order }, auth: true });
  },
  removeBuyItWith(product_id: string, related_product_id: string): Promise<{ ok: true }> {
    return api(`/admin/products/${product_id}/buy-it-with/${related_product_id}`, { method: 'DELETE', auth: true });
  },

  // ---- Admin: shipping areas ----
  adminShippingAreas(): Promise<{ items: any[] }> {
    return api('/admin/shipping-areas', { auth: true });
  },
  createShippingArea(body: Record<string, unknown>): Promise<{ id: string }> {
    return api('/admin/shipping-areas', { method: 'POST', body, auth: true });
  },
  updateShippingArea(id: string, body: Record<string, unknown>): Promise<{ ok: true }> {
    return api(`/admin/shipping-areas/${id}`, { method: 'PUT', body, auth: true });
  },
  removeShippingArea(id: string): Promise<{ ok: true }> {
    return api(`/admin/shipping-areas/${id}`, { method: 'DELETE', auth: true });
  },
};
